import { render, staticRenderFns } from "./mold_repairing.vue?vue&type=template&id=0a72459a&scoped=true&"
import script from "./mold_repairing.vue?vue&type=script&lang=js&"
export * from "./mold_repairing.vue?vue&type=script&lang=js&"
import style0 from "./mold_repairing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mold_repairing.vue?vue&type=style&index=1&id=0a72459a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72459a",
  null
  
)

export default component.exports